import { compact, isEmpty } from 'lodash'

export const defaultSelectedItem = (
  allItems = [],
  initialItemUuid = '',
  selectedItemUuid = '',
  modifierUuid = ''
) => {
  const initialItem = allItems?.find(
    (item) => item.uuid === initialItemUuid
  )

  const newSelectedItem = allItems?.filter(
    (item) => item.uuid === selectedItemUuid
  )

  const initialItemExternalRefIds = compact(
    initialItem?.itemCategoryExternalRefIds?.filter(
      (refId) => refId !== modifierUuid
    )
  )
  const newSelectedItemExternalRefIds = compact(
    newSelectedItem[0]?.itemCategoryExternalRefIds
  )

  // Default selected item requirments

  // clear/remove when: 1. user remove selected modifier from modifiers drawer
  // which was default selected modifier; 2. user deselect default modifier

  const isRemoved =
    !isEmpty(initialItemUuid) && isEmpty(selectedItemUuid)

  // added is true just in Add Modifier Group drawer, when user set default selected item
  const isAdded =
    isEmpty(initialItemUuid) && !isEmpty(selectedItemUuid)

  // updated when user change default selected item with new one
  const isUpdated =
    !isEmpty(selectedItemUuid) && initialItemUuid !== selectedItemUuid

  switch (true) {
    case isRemoved:
      return [
        {
          ...initialItem,
          itemCategoryExternalRefIds: initialItemExternalRefIds,
          itemCategoryPreferences: {
            [modifierUuid]: {
              ...initialItem?.itemCategoryPreferences[modifierUuid],
              defaultModifier: false,
            },
          },
        },
      ]

    case isAdded:
      return [
        {
          ...newSelectedItem[0],
          itemCategoryExternalRefIds: [
            ...newSelectedItemExternalRefIds,
            modifierUuid,
          ],
          itemCategoryPreferences: {
            [modifierUuid]: {
              ...newSelectedItem[0]?.itemCategoryPreferences[
                modifierUuid
              ],
              defaultModifier: true,
            },
          },
        },
      ]

    case isUpdated:
      return [
        {
          ...newSelectedItem[0],
          itemCategoryExternalRefIds: [
            ...newSelectedItemExternalRefIds,
            modifierUuid,
          ],
          itemCategoryPreferences: {
            [modifierUuid]: {
              ...newSelectedItem[0]?.itemCategoryPreferences[
                modifierUuid
              ],
              defaultModifier: true,
            },
          },
        },
        {
          ...initialItem,
          itemCategoryExternalRefIds: initialItemExternalRefIds,
          itemCategoryPreferences: {
            [modifierUuid]: {
              ...initialItem?.itemCategoryPreferences[modifierUuid],
              defaultModifier: false,
            },
          },
        },
      ]
    default:
      return []
  }
}

export const modifiersMappingMinMaxOrderCount = (modifiers) => {
  return (
    modifiers?.reduce((acc, modifier) => {
      const { uuid, orderMinCount, orderMaxCount } = modifier
      return [
        ...acc,
        {
          orderMinCount: orderMinCount ?? '',
          orderMaxCount: orderMaxCount ?? '',
          uuid,
        },
      ]
    }, []) ?? []
  )
}
